import { defineStore } from 'pinia';

export const usePageDataStore = defineStore('pageDataStore', () => {
    const pageStatus = ref<string>('');
    const pageLanguage = ref<string>('en');

    function updatePageStatus(statusString: string) {
        pageStatus.value = statusString;
    }

    function updatePageLanguage(localeCode: string) {
        pageLanguage.value = localeCode;
    }

    return {
        pageStatus,
        pageLanguage,
        updatePageStatus,
        updatePageLanguage,
    };
});
